import React from 'react';

export interface FootNoteProps_t {
    refNumber: number;
}

function getFootNoteRefId(id: number): string {
    return `${id}-footNoteRef`;
}

function getFootNoteId(id: number): string {
    return `${id}-footNote`;
}

function makeScrollTo(id: string): (e: React.MouseEvent) => void {
    return (e) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "instant" });
    }
}

export const Footnote: React.FC<FootNoteProps_t> = (props) => {
    return (<sup id={getFootNoteId(props.refNumber)}>
        <a href={`#${getFootNoteRefId(props.refNumber)}`}
            onClick={makeScrollTo(getFootNoteRefId(props.refNumber))}
        >
            {props.refNumber}
        </a>
    </sup>);
};

export interface FootNoteRefProps_t {
    refNumber: number;
    text?: string;
    ref: string;
}

export const FootnoteRef: React.FC<FootNoteRefProps_t> = (props) => {
    return (
        <sup>
            <li id={getFootNoteRefId(props.refNumber)}>
                <button 
                    className="back-arrow-btn" 
                    title='Back to text' 
                    onClick={makeScrollTo(getFootNoteId(props.refNumber))}
                >
                    <span className="back-arrow">↩</span>
                </button>
                {props.text}
                <a href={props.ref}>
                    {props.ref}
                </a>

            </li>

        </sup>);
};
